import axios from 'axios';
import { accessToken } from 'utils/auth0/auth0';
import { app } from 'utils';

export const appAxios = axios.create({
  headers: {
    'Content-type': 'application/json',
  },
});

export const multipartAppAxios = axios.create({
  headers: {
    'Content-type': 'multipart/form-data',
  },
});

export const authAxios = axios.create({
  headers: {
    'Content-type': 'application/json',
  },
});

appAxios.interceptors.request.use(
  async (config) => {
    const appConfig = await app.getConfig();
    const token = await accessToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    config.baseURL = `${appConfig.endpoint.edge}/api`;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

multipartAppAxios.interceptors.request.use(
  async (config) => {
    const appConfig = await app.getConfig();
    const token = await accessToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    config.baseURL = `${appConfig.endpoint.edge}/api`;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

authAxios.interceptors.request.use(
  async (config) => {
    const appConfig = await app.getConfig();
    const token = await accessToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    config.baseURL = `${appConfig.endpoint.auth}/api`;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
